module.exports = __webpack_public_path__ + "img/taiwan_3.b9fbb812.png";